import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import { customFuncsApi } from '../../../api'
import { ErrorModal } from '../index'
import ClipLoader from 'react-spinners/ClipLoader'
import ImeiModal from './ImeiModal/index'
import { roundCurrency } from '../../../utils'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { formatNumberWithIntl } from '../../../lib/FormatNumbersWithIntl'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		width: '90%',
		maxHeight: '100vh', // To make modal content scrollable if it exceeds viewport height
		// overflowY: 'auto',
	},
	overlay: {
		background: '#00000099',
	},
}

const ViewS = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	isLoading = false,
	onUpdated = () => {},
}) => {
	const errorModalRef = useRef()
	const imeiModalRef = useRef()
	const navigate = useNavigate()

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(false)
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState('')

	useEffect(() => {
		const ref = {
			open: (data) => {
				getOneSales(data?.SlpCode, data?.startDate, data?.endDate)
				setIsOpenModal(true)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	const getOneSales = (slpCode, startDate, endDate) => {
		setLoading(true)
		customFuncsApi
			.get(`XsSql/getInvoices?SlpCode=${slpCode}`, {
				params: {
					date1: startDate,
					date2: endDate,
				},
				headers: {
					Prefer: 'odata.maxpagesize=100000',
				},
			})
			.then((res) => {
				const data = res.data.value
				setData(data)
			})
			.catch((err) => {
				errorModalRef.current?.open(
					JSON.stringify(err.response.data?.details?.message),
				)
			})
			.finally(() => {
				setLoading(false)
			})
	}

	const switchTypeInvoice = (installmentId) => {
		if (installmentId <= 1) {
			return 'Наличные'
		} else {
			return 'Рассрочка'
		}
	}

	const viewItem = (v) => {
		navigate('/viewItem', { state: v })
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<div className="card">
				{loading ? (
					<div className="flex items-center justify-center">
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					</div>
				) : (
					<div className=" w-full overflow-auto  mb-8 ">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
								<tr>
									<th scope="col" className="px-6 py-4">
										Дата продажи
									</th>
									<th scope="col" className="px-6 py-4">
										Имя Клиента
									</th>
									<th scope="col" className="px-6 py-4">
										Товар
									</th>
									<th scope="col" className="px-6 py-4">
										Имеи
									</th>
									<th scope="col" className="px-6 py-4">
										Условия продажи
									</th>

									<th scope="col" className="px-6 py-4">
										Сумма
									</th>
									<th scope="col" className="px-6 py-4">
										Филиал
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((v, i) => {
									console.log('Month', get(v, 'Installmnt', '-'))
									return (
										<tr
											key={i}
											onClick={() => viewItem(v)}
											className="bg-white border-b  hover:bg-gray-50 "
										>
											<td className="px-6 py-4">
												{moment(get(v, 'DocDate', '-')).format('DD-MM-YYYY')}
											</td>
											<td className="px-6 py-4">{get(v, 'CardName', '-')}</td>
											<td className="px-6 py-4">{get(v, 'Dscription', '-')}</td>
											<td className="px-6 py-4">{get(v, 'IntrSerial', '-')}</td>
											<td className="px-6 py-4">
												{switchTypeInvoice(get(v, 'Installmnt', '-'))}
											</td>

											<td className="px-6 py-4">
												{formatNumberWithIntl(get(v, 'DocTotal', '-'))}
											</td>
											<td className="px-6 py-4">{get(v, 'WhsCode', '-')}</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
			<ImeiModal getRef={(r) => (imeiModalRef.current = r)} />

			<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
		</Modal>
	)
}

export default ViewS
